import $axios from "../../api";

const state = {
  userProfile: "",
  isLoading: false,
  errors: "",
  isSuccess: false,
  currentUser: null,
};

const mutations = {
  SET_PROFILE(state, payload) {
    state.userProfile = payload;
  },
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_CURRENT_USER(state, payload) {
    state.currentUser = payload;
  },
};

const actions = {
  async fetchCurrentUser({ commit }) {
    try {
      const res = await $axios.get("/me");
      commit("SET_CURRENT_USER", res.data);
    } catch (e) {
      console.error("Gagal ambil user:", e);
    }
  },
  updatePassword({ commit, state, dispatch }, payload) {
    commit("SET_LOADING", true);
    commit("SET_SUCCESS", false);
    return new Promise((resolve, reject) => {
      $axios
        .post(`profile/updatepassword`, payload)
        .then((response) => {
          commit("SET_LOADING", false);
          commit("SET_SUCCESS", true);
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response.data.errors);
          commit("SET_SUCCESS", false);
          commit("SET_LOADING", false);
          dispatch('Main/globalSweetAlert', error.response, { root: true })
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
